import type React from 'react';
import { faLeaf } from '@fortawesome/pro-solid-svg-icons';
import { faSack } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface WaybillIconProps {
  type: cyrian.api.products.Type;
  isEudrCompliant?: boolean;
}

interface ProductSettngs {
  letter: string;
  styles: Record<'l1' | 'l2' | 'l3', Record<string, unknown>>;
}

const typeSettings: Record<cyrian.api.products.Type, ProductSettngs> = {
  Utz: {
    letter: 'U',
    styles: {
      l1: {
        color: 'purple',
        '--fa-secondary-opacity': 0.5,
      },
      l2: {
        color: 'purple',
        '--fa-primary-color': 'grey',
        '--fa-secondary-opacity': 1.0,
      },
      l3: {
        color: 'purple',
        '--fa-secondary-opacity': 0.5,
      },
    },
  },
  'Fair trade': {
    letter: 'F',
    styles: {
      l1: {
        color: 'blue',
        '--fa-secondary-opacity': 0.5,
      },
      l2: {
        color: 'blue',
        '--fa-primary-color': 'grey',
        '--fa-secondary-opacity': 1.0,
      },
      l3: {
        color: 'blue',
        '--fa-secondary-opacity': 0.5,
      },
    },
  },
  'Rainforest alliance': {
    letter: 'R',
    styles: {
      l1: {
        color: 'green',
        '--fa-secondary-opacity': 0.5,
      },
      l2: {
        color: 'green',
        '--fa-primary-color': 'grey',
        '--fa-secondary-opacity': 1.0,
      },
      l3: {
        color: 'green',
        '--fa-secondary-opacity': 0.5,
      },
    },
  },
  Ordinary: {
    letter: '',
    styles: {
      l1: {
        color: 'brown',
        '--fa-secondary-opacity': 0.5,
      },
      l2: {
        '--fa-primary-color': 'grey',
        '--fa-secondary-color': 'brown',
        '--fa-secondary-opacity': 1.0,
      },
      l3: {
        color: 'brown',
        '--fa-secondary-opacity': 0.5,
      },
    },
  },
  'Cocoa Life': {
    letter: 'L',
    styles: {
      l1: {
        color: 'orange',
        '--fa-secondary-opacity': 0.5,
      },
      l2: {
        color: 'orange',
        '--fa-primary-color': 'grey',
        '--fa-secondary-opacity': 1.0,
      },
      l3: {
        color: 'orange',
        '--fa-secondary-opacity': 0.5,
      },
    },
  },
  'Premius Cyrian': {
    letter: 'P',
    styles: {
      l1: {
        color: 'darkred',
        '--fa-secondary-opacity': 0.5,
      },
      l2: {
        color: 'darkred',
        '--fa-primary-color': 'grey',
        '--fa-secondary-opacity': 1.0,
      },
      l3: {
        color: 'darkred',
        '--fa-secondary-opacity': 0.5,
      },
    },
  },
};

const unknownProductSettings: ProductSettngs = {
  letter: '?',
  styles: {
    l1: {
      color: 'grey',
      '--fa-secondary-opacity': 0.5,
    },
    l2: {
      '--fa-primary-color': 'grey',
      '--fa-secondary-color': 'grey',
      '--fa-secondary-opacity': 1.0,
    },
    l3: {
      color: 'grey',
      '--fa-secondary-opacity': 0.5,
    },
  },
};

export const WaybillIcon = ({ type, isEudrCompliant }: WaybillIconProps) => {
  const {
    letter,
    styles: { l1, l2, l3 },
  } = typeSettings[type] ?? unknownProductSettings;

  return (
    <span className="fa-stack">
      {/* <FontAwesomeIcon icon={faSack} className="fa-stack-2x" style={l1 as React.CSSProperties} /> */}
      <FontAwesomeIcon
        icon={faSack}
        transform={'shrink-1 left-14 up-4'}
        className="fad fa-stack-1x"
        style={l1 as React.CSSProperties}
      />
      <FontAwesomeIcon
        icon={faSack}
        transform={'shrink-1 up-2'}
        className="fad fa-stack-2x"
        style={l2 as React.CSSProperties}
      />
      <FontAwesomeIcon
        icon={faSack}
        transform={'shrink-1 right-14 up-4'}
        className="fad fa-stack-1x"
        style={l3 as React.CSSProperties}
      />
      {letter && (
        <span className="fa-layers-text fa-inverse" data-fa-transform="shrink-8 up-1" style={{ fontWeight: 'bold' }}>
          {letter}
        </span>
      )}
      {isEudrCompliant && (
        <FontAwesomeIcon
          icon={faLeaf}
          className="fa-stack-1x"
          style={{ color: 'green' }}
          transform="shrink-4 up-20 right-15"
        />
      )}
    </span>
  );
};
